import React from 'react';
import Select from '../../reusable/Select/Select';
import ErrorField from '../ErrorField';
import LabelField from '../LabelField';
import PropTypes from 'prop-types';

const BudgetTypeSelect = ({ value, error, options, onChange }) => {
  return (
    <>
      <LabelField>Budget Type</LabelField>
      {error && <ErrorField>{error}</ErrorField>}
      <Select
        name="type"
        placeHolder="Select The Budget Type"
        options={options}
        value={value}
        onChange={(val, meta) => onChange(val, meta)}
      />
    </>
  );
};

BudgetTypeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(BudgetTypeSelect);
